import { workSeqFromMessageId } from '@/constants/work';

export function workQuestionHistory(events = [], { resolvedIds = [] } = {}) {
  const questions = new Map();
  for (const event of events) {
    if (event?.type === 'user_question_requested' && event.id) questions.set(event.id, event);
    else if (event?.type === 'user_question_resolved'
      && (event.answer || event.optionId || event.skipped || event.timedOut || event.reason === 'user_cancelled')) questions.delete(event.id);
    else if (event?.type === 'session_end' && event.status === 'stopped') questions.clear();
  }
  const resolved = new Set(resolvedIds);
  return [...questions.values()].filter(question => !resolved.has(question.id));
}

function sequence(row) {
  if (row?.type === 'group') return Math.max(0, ...(row.messages || []).map(sequence));
  return workSeqFromMessageId(row?.id || row?._id) || 0;
}

// Question controls live outside folded activity and stay at their original
// place in the transcript, even after newer messages or a browser refresh.
export function insertWorkQuestionHistory(rows, questions, visibleId) {
  const result = [...rows];
  for (const question of questions || []) {
    if (question.id === visibleId) continue;
    const id = `work-question-history-${question.id}`;
    let index = result.findIndex(row => sequence(row) > Number(question.seq));
    if (index < 0) {
      index = result.length;
      while (index > 0 && result[index - 1]?.type === 'work-live-activity') index--;
    }
    result.splice(index, 0, { id, _stableKey: id, type: 'work-question-history', question });
  }
  return result;
}
